import { Button, CssBaseline, Grid, Typography } from "@material-ui/core";
import { useAppContext } from "context/AuthContext";
import { useHistory } from "react-router";
import EnumGroup from "utils/enum/EnumGroup";
import LabelsContext from "../../../lang/LabelsContext";
import ArticleCard from "../article-card/ArticleCard";
import AssistantEditorToDoListService, { AssistantEditorToDoListServiceType } from "./AssistantEditorToDoListService";
import useStyles from "./AssistantEditorToDoListStyle";

export default function AssistantEditorToDoList() {
  const classes = useStyles();
  const { authData } = useAppContext();

  const { Labels } = LabelsContext();

  const { articleList }: AssistantEditorToDoListServiceType = AssistantEditorToDoListService();

  const history = useHistory();

  const rightButtons = (id: any) => (
    <Grid container spacing={1}>
      {[EnumGroup.EDITOR, EnumGroup.ASSOCIATE_EDITOR, EnumGroup.ASSISTANT].includes(authData?.user?.group.group) && (
        <Grid item>
          <Button variant="contained" size="small" onClick={() => history.push(`/manageFiles/${id}`)}>
            Manage files
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button variant="contained" size="small" onClick={() => history.push(`/checkManuscript/${id}`)}>
          {Labels.ACTION}
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <>
      <CssBaseline />
      <Typography variant="h5">{Labels.TO_DO_LIST}</Typography>
      {articleList?.map((article: any, index: number) => (
        <Grid className={classes.grid} xs={12} sm={12}>
          <ArticleCard data={article} index={index} rightComponent={() => rightButtons(article.id)} animation={true} />
        </Grid>
      ))}
    </>
  );
}
